import { chatQueryKeys as e } from "./useChatQueryKeys.mjs";
import { useInfiniteList as t, useInfiniteQuery as n } from "@maat/store-hooks";
import { chatApi as r } from "@maat/api-chat";
//#region src/hooks/useConversationsQuery.ts
var i = 30, a = (a, o) => {
	let s = o?.inboxType, c = o?.tab, l = o?.unreadOnly || void 0, u = o?.q?.trim() || void 0;
	return t(n({
		queryKey: e.conversations({
			referenceId: a,
			inboxType: s,
			tab: c,
			unreadOnly: l,
			q: u
		}),
		queryFn: async ({ pageParam: e }) => r.getConversations({
			limit: i,
			offset: e,
			reference_id: a,
			inbox_type: s,
			tab: c,
			unread_only: l,
			q: u
		}),
		initialPageParam: 0,
		enabled: o?.enabled ?? !0,
		getNextPageParam: (e, t) => e.hasMore ? t.reduce((e, t) => e + t.conversations.length, 0) : void 0
	}), "conversations");
};
//#endregion
export { a as useConversationsQuery };
